import React, { useState, useEffect } from "react";
import { Box, Flex, Image, Heading, Text } from "@chakra-ui/react";
import Countdown from "react-countdown"; // Import Countdown package
import videoImg from "../../assets/images/vm.png";
import AnimatedSection from "./AnimatedSection";
import Animated from "./AnimatedSection";

const EVENT_DATE = new Date("2025-05-03T00:00:00").getTime();

const VideoTimerSection = () => {
  const [timeRemaining, setTimeRemaining] = useState(
    EVENT_DATE - new Date().getTime()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(EVENT_DATE - new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formUrl =
  "https://forms.zohopublic.com/IDEATORSCUP/form/CYPRUSROUNDREGISTRATION/formperma/Tyx16DXRUfRvZhmvGzZIq3-AiDXmFma208KpF8Ib9S4";

const handleRegisterClick = () => {
  window.open(formUrl, "_blank", "noopener,noreferrer");
};

  // Countdown renderer function
  const renderer = ({ days, hours, minutes, seconds }) => (
    <Flex mt={4} gap={4} flexWrap="wrap">
      <Box>
        <Heading fontSize={{ base: "22px", lg: "36px" }} fontWeight={"400"}>
          {days}
        </Heading>
        <Heading fontSize={{ base: "12px", lg: "16px" }} fontWeight={"400"}>
          Days
        </Heading>
      </Box>
      <Box>
        <Heading fontSize={{ base: "22px", lg: "36px" }} fontWeight={"400"}>
          {hours}
        </Heading>
        <Heading fontSize={{ base: "12px", lg: "16px" }} fontWeight={"400"}>
          Hours
        </Heading>
      </Box>
      <Box>
        <Heading fontSize={{ base: "22px", lg: "36px" }} fontWeight={"400"}>
          {minutes}
        </Heading>
        <Heading fontSize={{ base: "12px", lg: "16px" }} fontWeight={"400"}>
          Minutes
        </Heading>
      </Box>
      <Box>
        <Heading fontSize={{ base: "22px", lg: "36px" }} fontWeight={"400"}>
          {seconds}
        </Heading>
        <Heading fontSize={{ base: "12px", lg: "16px" }} fontWeight={"400"}>
          Seconds
        </Heading>
      </Box>
    </Flex>
  );

  return (
    <AnimatedSection>
      <Flex
        gap={5}
        w="90%"
        m="auto"
        my={4}
        color="white"
        alignItems={"stretch"}
        flexDirection={{ base: "column", lg: "row" }}
      >
        <Box
          borderRadius={"16px"}
          w={{ base: "100%", lg: "70%" }}
          bg="brand.100"
          p={4}
        >
          <Image w="100%" h="100%" objectFit="cover" src={videoImg} />
        </Box>
        <Box p={4} borderRadius={"16px"} w="100%" bg="brand.100">
          <Animated>
            <Flex
              gap={2}
              justifyContent="space-between"
              flexDirection={{ base: "column", lg: "row" }}
            >
              <Box>
                <Heading
                  color="brand.200"
                  fontSize={{ base: "2xl", lg: "3xl" }}
                >
                  NORTH CYPRUS
                </Heading>
                <Text
                  fontSize={{ base: "16px", lg: "18px" }}
                  mt={{ base: 2, lg: 4 }}
                >
                  Get Ready Bring your A-game
                  <br></br>
                  The countdown to the next big event has begun!
                </Text>
              </Box>
            </Flex>
          </Animated>

          {/* Timer Section */}
          <Animated>
            <Countdown date={Date.now() + timeRemaining} renderer={renderer} />

            <Box  onClick={handleRegisterClick} cursor={'pointer'} mt={{ base: 6, lg: 12 }}>
              <Heading
                p={3}
                fontSize={{ base: "16px", lg: "18px" }}
                color="white"
                fontWeight={"500"}
                bg="brand.150"
                borderRadius="lg"
              >
                Register for our next event in Cyprus
              </Heading>
            </Box>
          </Animated>
        </Box>
      </Flex>
    </AnimatedSection>
  );
};

export default VideoTimerSection;
